import React, { useState, useMemo, useFetchJson } from "react";
import {
  AllCommunityModule,
  ModuleRegistry,
  ValidationModule,
} from "ag-grid-community";
// Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css";
import "@/App.css";
import { AgGridReact } from "ag-grid-react";

ModuleRegistry.registerModules([AllCommunityModule]);
if (import.meta.env.NODE_ENV !== "production") {
  ModuleRegistry.registerModules([ValidationModule]);
}

export default function DataTableStaff({ statsAmbassadors = { data: [], pagination: {} } }) {
  // Transform backend data to match the expected format
  const rowData = useMemo(() => {
    if (!statsAmbassadors?.data || statsAmbassadors.data.length === 0) {
      return [];
    }
    
    return statsAmbassadors.data.map((item, index) => ({
      id: index + 1,
      nombre: item.nombreCompleto || 'N/A',
      instagram: item.instagram || 'N/A',
      totalClicks: item.totalClicksEnlaceReferido || 0,
      totalConversions: item.totalConversiones || 0,
      totalVendido: item.totalVentasGeneradas || 0,
      comision: item.totalComisionGenerada || 0,
      totalInvitaciones: item.totalInvitaciones || 0,
      invGratis: item.invGratis || 0,
      invConDescuento: item.invConDescuento || 0,
      invPagoTotal: item.invPagoTotal || 0,
      invGratisTotal: item.invGratisTotal || 0,
      invRechazadas: item.invRechazadas || 0,
      invPendientes: item.invPendientes || 0,
    }));
  }, [statsAmbassadors]);

  // Sample data based on the reference image

  // Status badge select renderer
  const StatusCellRenderer = (params) => {
    const status = params.value;
    let bgColor = "bg-gray-200 text-gray-800";
    let text = "Desconocido";
    if (status === "aprovado") {
      bgColor = "bg-green-100 text-green-800";
      text = "Aprobado";
    } else if (status === "confirmado") {
      bgColor = "bg-blue-100 text-blue-800";
      text = "Confirmado";
    } else if (status === "pendiente") {
      bgColor = "bg-yellow-100 text-yellow-800";
      text = "Pendiente";
    } else if (status === "cancelado") {
      bgColor = "bg-red-100 text-red-800";
      text = "Cancelado";
    }
    return (
      <span
        className={`px-2 py-1 rounded-full text-xs font-semibold ${bgColor}`}
      >
        {text}
      </span>
    );
  };

  // Currency formatter
  const currencyFormatter = (params) => {
    if (params.value) {
      return new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        minimumFractionDigits: 0,
      }).format(params.value);
    }
    return "$0";
  };

  // Instagram link renderer
  const InstagramCellRenderer = (params) => {
    // ontener solo el nombre de usuario, el value viene puede venir "https://instagram.com/username" o "https://www.instagram.com/username" o solo "username"
    let username = params.value;
    if (username.startsWith("https://www.instagram.com/")) {
      username = username.replace("https://www.instagram.com/", "");
    }
    if (username.startsWith("https://instagram.com/")) {
      username = username.replace("https://instagram.com/", "");
    }
    if (username.startsWith("@")) {
      username = username.substring(1);
    }

    return (
      <a
        href={`https://instagram.com/${username}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-aw-green/85 hover:text-aw-green hover:underline"
      >
        {`@${username}`}
      </a>
    );
  };

  // Column definitions
  const columnDefs = useMemo(
    () => [
      // Nombre
      {
        headerName: "Nombre",
        field: "nombre",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: {
          filterOptions: ["contains", "startsWith", "endsWith"],
          defaultOption: "startsWith",
        },
        minWidth: 180,
        cellStyle: { color: "hsl(72, 80%, 55%)" },
      },
      // Instagram
      {
        headerName: "Instagram",
        field: "instagram",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: {
          filterOptions: ["contains", "startsWith", "endsWith"],
          defaultOption: "startsWith",
        },
        cellRenderer: InstagramCellRenderer,
        maxWidth: 140,
      },
      // Total Control
      // {
      //   headerName: "Total Control",
      //   field: "totalControl",
      //   sortable: true,
      //   filter: "agNumberColumnFilter",
      //   filterParams: {
      //     filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
      //     defaultOption: "greaterThan",
      //   },
      //   width: 130,
      //   cellStyle: { textAlign: "center" },
      // },
      // Control Pagado
      // {
      //   headerName: "Control Pagado",
      //   field: "controlPagado",
      //   sortable: true,
      //   filter: "agNumberColumnFilter",
      //   filterParams: {
      //     filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
      //     defaultOption: "greaterThan",
      //   },
      //   width: 140,
      //   cellStyle: { textAlign: "center" },
      // },
      // Invitación Free
      // {
      //   headerName: "Invitación Free",
      //   field: "invitacionFree",
      //   sortable: true,
      //   filter: "agNumberColumnFilter",
      //   filterParams: {
      //     filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
      //     defaultOption: "greaterThan",
      //   },
      //   width: 130,
      //   cellStyle: { textAlign: "center" },
      // },
      // Invitación Con Descuento
      // {
      //   headerName: "Invitación Con Descuento",
      //   field: "invitacionConDescuento",
      //   sortable: true,
      //   filter: "agNumberColumnFilter",
      //   filterParams: {
      //     filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
      //     defaultOption: "greaterThan",
      //   },
      //   width: 130,
      //   cellStyle: { textAlign: "center" },
      // },
      // Total Clicks
      {
        headerName: "Total Clicks",
        field: "totalClicks",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        width: 130,
        cellStyle: { textAlign: "center" },
      },
      // Total Conversions
      {
        headerName: "Total Conversiones",
        field: "totalConversions",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        width: 130,
        cellStyle: { textAlign: "center" },
      },

      // Total Vendido
      {
        headerName: "Total Vendido",
        field: "totalVendido",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        valueFormatter: currencyFormatter,
        width: 130,
        cellStyle: { textAlign: "right", fontWeight: "bold" },
      },
      // Comisión
      {
        headerName: "Comisión",
        field: "comision",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: {
          filterOptions: ["equals", "greaterThan", "lessThan", "inRange"],
          defaultOption: "greaterThan",
        },
        valueFormatter: currencyFormatter,
        width: 130,
        cellStyle: { textAlign: "right", fontWeight: "bold" },
      },
      {
        headerName: "Total Inv.",
        field: "totalInvitaciones",
        sortable: true,
        filter: "agNumberColumnFilter",
        width: 110,
        cellStyle: { textAlign: "center", fontWeight: "bold" },
      },
      {
        headerName: "Inv. Gratis",
        field: "invGratis",
        sortable: true,
        filter: "agNumberColumnFilter",
        width: 110,
        cellStyle: { textAlign: "center", color: "hsl(72, 80%, 55%)" },
      },
      {
        headerName: "Inv. c/Dscto",
        field: "invConDescuento",
        sortable: true,
        filter: "agNumberColumnFilter",
        width: 120,
        cellStyle: { textAlign: "center", color: "#EAB308" },
      },
      {
        headerName: "Inv. Pago",
        field: "invPagoTotal",
        sortable: true,
        filter: "agNumberColumnFilter",
        width: 100,
        cellStyle: { textAlign: "center", color: "#A855F7" },
      },
      {
        headerName: "Free Total",
        field: "invGratisTotal",
        sortable: true,
        filter: "agNumberColumnFilter",
        width: 100,
        cellStyle: { textAlign: "center" },
      },
      {
        headerName: "Rechazadas",
        field: "invRechazadas",
        sortable: true,
        filter: "agNumberColumnFilter",
        width: 110,
        cellStyle: { textAlign: "center", color: "#EF4444" },
      },
      {
        headerName: "Pendientes",
        field: "invPendientes",
        sortable: true,
        filter: "agNumberColumnFilter",
        width: 110,
        cellStyle: { textAlign: "center", color: "#F97316" },
      },
      // Estado
      // {
      //   headerName: "Estado",
      //   field: "estado",
      //   sortable: true,
      //   filter: "agTextColumnFilter",
      //   editable: true,
      //   filterParams: {
      //     filterOptions: ["contains", "startsWith", "endsWith"],
      //     defaultOption: "startsWith",
      //   },
      //   cellRenderer: StatusCellRenderer,
      //   cellEditor: "agSelectCellEditor",
      //   cellEditorParams: {
      //     values: ["aprovado", "confirmado", "pendiente", "cancelado"],
      //   },
      //   width: 120,
      //   cellStyle: { textAlign: "center" },
      // },
    ],
    []
  );

  // Grid options
  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      sortable: true,
      filter: true,
      floatingFilter: false,
    }),
    []
  );

  return (
    <div className="w-full h-full">
      {/* Header */}
      <div className="pb-4 ">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-white">
              Estado del Staff
            </h2>
          </div>
          {/* <div className="flex items-center space-x-3">
            <button className="bg-aw-green scale-100 hover:scale-95 duration-300 text-aw-bluedark px-4 py-2 rounded-lg font-semibold transition">
              + Link Invitación
            </button>
          </div> */}
        </div>
      </div>

      {/* Data Grid */}
      <div className="">
        <div className="ag-theme-quartz w-full" style={{ height: "600px" }}>
          <AgGridReact
            rowData={rowData}
            // loading={loading}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            pagination={true}
            // paginationPageSize={10}
            // rowSelection="multiple"
            // suppressMenuHide={true}
            // animateRows={true}
            // rowHeight={60}
            // headerHeight={50}
            // floatingFiltersHeight={40}
            // enableCellTextSelection={true}
            // rowClassRules={{
            //   'bg-green-50': (params) => params.data.estado === 'aprovado',
            //   'bg-blue-50': (params) => params.data.estado === 'confirmado',
            //   'bg-yellow-50': (params) => params.data.estado === 'pendiente',
            //   'bg-red-50': (params) => params.data.estado === 'cancelado'
            // }}
            // onGridReady={(params) => {
            //   params.api.sizeColumnsToFit()
            // }}
            // onFirstDataRendered={(params) => {
            //   params.api.sizeColumnsToFit()
            // }}
          />
        </div>
      </div>

      {/* Footer Stats */}
      <div className="px-6 py-4  bg-aw-bluedark-50">
        <div className="flex items-center justify-between text-sm text-gray-200">
          <div>
            Mostrando {rowData.length} registros de {rowData.length} total
          </div>
          <div className="flex items-center space-x-4">
            <div>
              Total Comisiones:{" "}
              {currencyFormatter({
                value: rowData.reduce((sum, row) => sum + row.comision, 0),
              })}
            </div>
            <div>
              Aprobados:{" "}
              {rowData.filter((row) => row.estado === "aprovado").length}
            </div>
            <div>
              Pendientes:{" "}
              {rowData.filter((row) => row.estado === "pendiente").length}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
